import { createRouter, createWebHistory } from 'vue-router';
import CompanionLayout from './layouts/CompanionLayout.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      name: 'companionPair',
      path: '/pair',
      component: () => import('./views/CompanionPairingView.vue'),
    },
    {
      // Where a session lands once it expired or was ended on the desktop.
      name: 'companionSessionEnded',
      path: '/ended',
      meta: { hide: true, public: true },
      component: () => import('./views/CompanionSessionEndedView.vue'),
    },
    {
      name: 'notFound',
      path: '/:pathMatch(.*)*',
      meta: { hide: true, public: true },
      component: import('../views/NotFoundView.vue'),
    },
    {
      name: 'forbidden',
      path: '/forbidden',
      meta: { hide: true },
      component: () => import('../views/ForbiddenView.vue'),
    },
    {
      path: '/session/:sessionId',
      component: CompanionLayout,
      children: [
        {
          name: 'companionSessionRoot',
          path: '',
          components: {
            default: () => import('./views/CompanionHomeView.vue'),
            header: () => import('./components/CompanionSessionHeader.vue'),
          },
        },
        {
          name: 'companionSessionFileSync',
          path: 'file-sync',
          components: {
            default: () => import('./views/CompanionFileSyncView.vue'),
            header: () => import('./components/CompanionSessionHeader.vue'),
            footer: () => import('./components/CompanionSessionFooter.vue'),
          },
        },
        {
          name: 'companionSessionOfferCreate',
          path: 'offer-create',
          components: {
            default: () => import('./views/CompanionOfferCreateView.vue'),
            header: () => import('./components/CompanionSessionHeader.vue'),
            footer: () => import('./components/CompanionSessionFooter.vue'),
          },
        },
        {
          name: 'companionSessionBarcodeScanner',
          path: 'barcode-scanner',
          components: {
            default: () => import('./views/CompanionBarcodeScannerView.vue'),
            header: () => import('./components/CompanionSessionHeader.vue'),
            footer: () => import('./components/CompanionSessionFooter.vue'),
          },
        },
      ],
    },
  ],
});

export default router;
